import { loc } from "../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import FormController from "../util/FormController.js";
import FormType from "../util/FormType.js";
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var PollController = FormController.extend({
  className: "poll",
  Model: {
    save: function() {
      this.trigger("cancelRequest");
      return this.appState.get("transaction").cancel().then(() => {
        this.options.appState.trigger("navigate", "");
      }).catch(() => {
        this._stopCountDown();
      });
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: function() {
      return this.title;
    },
    className: "poll-controller",
    noCancelButton: true,
    save: loc("oform.cancel", "login"),
    modelEvents: {
      cancelRequest: "_stopCountDown"
    },
    formChildren: [FormType.View({
      View: '<div >               <div data-se="poll-waiting" class="hide okta-waiting-spinner"></div>             </div>'
    })],
    _checkStatus: function() {
      this.transactionObject.poll().then((resp) => {
        if (resp.data && resp.status !== "POLL") {
          this.options.appState.set("transaction", resp);
          return;
        }
        this.$(".okta-waiting-spinner").hide();
        let factorPollingIntervalSeconds = Math.ceil(resp.transaction.profile.refresh / 1e3);
        this._startCountDown(factorPollingIntervalSeconds);
      }).catch(() => {
        this._stopCountDown();
      });
    },
    _startCountDown: function(factorPollingIntervalSeconds) {
      this.countDown = setInterval(() => {
        this._updateTitle(factorPollingIntervalSeconds);
        if (factorPollingIntervalSeconds === 0) {
          this._stopCountDown();
          this.$(".okta-waiting-spinner").show();
          this.checkStatusTimeout = setTimeout(() => {
            this._checkStatus();
          }, 200);
        } else {
          factorPollingIntervalSeconds = factorPollingIntervalSeconds - 1;
        }
      }, 1e3);
    },
    _updateTitle: function(factorPollingIntervalSeconds) {
      this.title = loc("polling.title", "login", [factorPollingIntervalSeconds]);
      this.$el.find(".okta-form-title").text(this.title);
    },
    _stopCountDown: function() {
      if (this.countDown) {
        clearInterval(this.countDown);
      }
      if (this.checkStatusTimeout) {
        clearInterval(this.checkStatusTimeout);
      }
    },
    initialize: function(options) {
      this.transactionObject = options.appState.get("transaction");
      this.factorPollingIntervalSeconds = Math.ceil(this.transactionObject.transaction.profile.refresh / 1e3);
      this._updateTitle(this.factorPollingIntervalSeconds);
      this._startCountDown(this.factorPollingIntervalSeconds);
    }
  },
  back: function() {
  },
  remove: function() {
    this.form._stopCountDown();
  }
});
export { PollController as default };
